import type { QueueTrafficInfo } from "@/models";
import { getSelectedSessionId } from "@/sdk";
import { getSharedApiClient } from "@/shared-utils";

export const updateQueueVolume = async (updatedQueues: QueueTrafficInfo[]): Promise<unknown> => {
    return await getSharedApiClient().post(`api/traffic-control/v1/queues`, {
        body: JSON.stringify(updatedQueues),
        headers: {
            "x-ewp-correlation-id": getSelectedSessionId(),
        },
    });
};
